import * as Store from '@/store';
export async function downloadTranscription(id) {
    if (typeof id !== 'number' || id < 0)
        throw 'id is invalid';
    const text = await Store.subtitles
        .downloadTranscript(id)
        .then((subtitleURL) => fetch(subtitleURL).then(response => response.text()));
    if (typeof text !== 'string')
        throw 'subtitle text is not a string.';
    return text;
}
